import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonSearchbar,
  IonButton,
  IonModal,
  IonItemDivider,
  IonInput,
  IonSpinner,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonToast,
  IonText,
  IonProgressBar
} from '@ionic/react';
import { connect } from 'react-redux';
import { add, close, send, star } from 'ionicons/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Select from 'react-select';

import './Sent.css';
import SentActions from '../../../actions/sent';
import ErrorAlert from '../../../components/ErrorAlert';

interface Props {
  getmessages: any;
  getsent: any;
  setData: any;
  sendMessages: any;
  changeFields: any;
  errorForm: any;
  getmessage: any;
  setDataConcat: any;
}

interface ClassState {
  showModal: boolean;
  showModalNew: boolean;
  data: any;
}

const colourStyles = {
    control: (styles:any) => ({ ...styles, backgroundColor: 'white', color: 'black'}),
    option: (styles:any) => ({ ...styles, backgroundColor: 'white', color: 'black', border: 0 }),
    multiValue: (styles:any) => ({ ...styles, backgroundColor: 'white', color: 'black', border: 0 }),
    multiValueLabel: (styles:any) => ({ ...styles, backgroundColor: '#5cb85c', color: 'white', border: 0 }),
    multiValueRemove: (styles:any) => ({ ...styles, backgroundColor: '#5cb85c', color: 'white', border: 0 }),
    singleValue: (styles:any) => ({ ...styles, color: 'white', backgroundColor: '#5cb85c'}),
};

class Sent extends React.Component<Props, ClassState> {
  ionInfiniteScrollRefProgram: React.RefObject<HTMLIonInfiniteScrollElement>;
  constructor(props: any) {
    super(props)
    this.ionInfiniteScrollRefProgram = React.createRef<HTMLIonInfiniteScrollElement>();
    this.state = {data: props.data, showModal:false, showModalNew:false}
  }

  componentDidMount(){
    if (this.state.data.sent.length === 0) {
      this.props.getmessages({pag: '1', show: '10', search: ''}, "get_messages");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });

    if (!nextProps.data.loading) {
      if (this.ionInfiniteScrollRefProgram.current) {
        this.ionInfiniteScrollRefProgram.current.complete();
      }
    }
  }

  handleSearch(event: any) {
    this.props.setData(event.target.value, "searchsent");
    if (this.state.data.searchsent.length === 0) {
      this.props.setData(1, "pagsent");
      this.props.setData([], "sent");
      this.props.getsent({pagsent: 1, searchsent: event.target.value}, "get_messages_send");
    }
  }

  Search(event: any) {
    if (this.state.data.searchsent.length > 0) {
      this.props.setData(1, "pagsent");
      this.props.setData([], "sent");
      this.props.getsent({pagsent: 1, searchsent: this.state.data.searchsent}, "get_messages_send");
    }
  }

  loadMoreItems(){
    if (!this.state.data.loadmoresent) {
      if (this.ionInfiniteScrollRefProgram.current) {
        this.ionInfiniteScrollRefProgram.current.complete();
      }
    }
    if (this.state.data.loadmoresent) {
      this.props.getsent({pagsent: this.state.data.pagsent, searchsent: this.state.data.searchsent}, "get_messages_send");
    }
  }

  sendMessage(){
    const fields = this.state.data.fields;
    fields.para = [];
    fields.para.push(this.state.data.fields.tutor);
    fields.sms = {contenido: this.state.data.fields.message, titulo: this.state.data.fields.subject};
    this.props.sendMessages(fields, "sent_messages_tutor");
  }

  statusModal(open: boolean, msg: any = null){
    this.props.setData([],"options");
    this.props.setData([],"options2");
    this.props.setData([],"selectedOption");
    this.props.setData([],"selectedOption2");
    if (open) {
      this.props.getmessage({nid: msg.nid}, "get_mensaje");
      let fields = this.state.data.fields;
      fields.subject = msg.titulo;
      fields.message = msg.contenido;
      fields.correoTutor = msg.correoorigen;
      this.props.changeFields(fields);
      this.props.errorForm({errors:{}});
    }else{
      this.setState({
        showModalNew: open
      });      
    }

    this.setState({
      showModal: open
    });
  }

  statusModalNew(open: boolean, msg: any = null){
    this.props.setData([],"options");
    this.props.setData([],"options2");
    this.props.setData([],"selectedOption");
    this.props.setData([],"selectedOption2");
    if (open) {
      this.props.getmessage({}, "auxiliares");
      let fields = this.state.data.fields;
      fields.subject = "";
      fields.message = "";
      this.props.changeFields(fields);
      this.props.errorForm({errors:{}});
    }

    this.setState({
      showModal: open,
      showModalNew: open
    });
  }

  handleChange(event: any) {
    let fields = this.state.data.fields;
    fields[event.target.name] = event.target.value;
    this.props.changeFields(fields)
  }

  handleChangeEditor(content: any) {
    let fields = this.state.data.fields;
    fields.message = content;
    this.props.changeFields(fields)
  }

  handleChangeSelect(selectedOption: any) {
    this.props.setData(selectedOption,"selectedOption");
  };

  handleChangeSelect2(selectedOption2: any) {
    this.props.setData(selectedOption2,"selectedOption2");
  };

  render(){
    const { sent, fields, simpleToast, toastMessage, formErrors, error, error401, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>

            <IonButtons slot="end">
              <IonButton onClick={this.statusModalNew.bind(this, true)}>
                <IonIcon icon={add} />
              </IonButton>
            </IonButtons>

            <IonTitle>{ sent.length > 0 && !error401 && !error ? "Mensajería" : error401 || error ? "Error en la petición" : "Cargando..." }</IonTitle>
          </IonToolbar>
          <IonToolbar color="primary">
            <IonSearchbar placeholder="Buscar..." type="search" inputmode="search" value={this.state.data.searchsent } onClick={this.Search.bind(this)} onIonChange={this.handleSearch.bind(this)}></IonSearchbar>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>

          <IonModal isOpen={this.state.showModal} >
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="end">
                  <IonButton onClick={this.sendMessage.bind(this)} disabled={true}>
                    <IonIcon icon={send} />
                  </IonButton>
                  <IonButton onClick={this.statusModal.bind(this, false)} disabled={this.state.data.loading}>
                    <IonIcon icon={close}/>
                  </IonButton>
                </IonButtons>
                <IonTitle>Nueva notificación</IonTitle>
              </IonToolbar>
            </IonHeader>

            <IonToast
              isOpen={simpleToast}
              buttons={[
                {
                  text: 'Ok',
                  role: 'cancel'
                }
              ]}
              message={`${toastMessage}`}
              duration={3000}
            />

            <IonContent >
              <IonProgressBar style={ this.state.data.loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
                <div style={ this.state.showModalNew ? {display: "none"} : {display: "block"} }>
                  <Select
                    value={this.state.data.selectedOption2}
                    onChange={this.handleChangeSelect2.bind(this)}
                    options={this.state.data.options2}
                    isMulti
                    placeholder="Para:"
                    styles={colourStyles}
                    isDisabled={this.state.data.loading}
                  />
                </div>
                <Select
                  value={this.state.data.selectedOption}
                  onChange={this.handleChangeSelect.bind(this)}
                  options={this.state.data.options}
                  isMulti
                  placeholder={this.state.showModalNew ? "Para:" : "Docentes:"}
                  isDisabled={this.state.data.loading}
                />
              <IonList id="inside-mce">
                <IonItem>
                  <IonInput name="subject" placeholder="Asunto"  value={fields.subject || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
                </IonItem>
                {formErrors.errors && formErrors.errors.subject && (
                  <IonText color="danger" className="ion-padding-start">
                    <small>{formErrors.errors.subject}</small>
                  </IonText>
                )}
                <IonItemDivider>Redactar mensaje</IonItemDivider>
                <ReactQuill theme="snow" value={fields.message || ""} onChange={this.handleChangeEditor.bind(this)}/>
                {formErrors.errors && formErrors.errors.message && (
                  <IonText color="danger" className="ion-padding-start">
                    <small>{formErrors.errors.message}</small>
                  </IonText>
                )}
              </IonList>
            </IonContent>
          </IonModal>

          <div style={ this.state.data.loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <IonList style={error || error401 && !loading ? {display: "none"} : {display: "block"} }>
            <h1 style={sent.length === 0 && !error && !error401 && !this.state.data.loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
            {sent.map((val:any, key:any) => {
              return (
                <IonItem key={key} onClick={this.statusModal.bind(this, true, val)}>
                  <IonIcon icon={star} color="primary" slot="end"/>
                  <IonLabel>
                    <h2>{val.name}</h2>
                    <h3>{val.creado}</h3>
                    <p>{val.titulo}</p>
                  </IonLabel>
                </IonItem>
              );
            })}
          </IonList>
          <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefProgram}  onIonInfinite={this.loadMoreItems.bind(this)}>
            <IonInfiniteScrollContent
              loadingSpinner="bubbles"
              loadingText="Cargando mas información...">      
            </IonInfiniteScrollContent>
          </IonInfiniteScroll>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    getmessages: PropTypes.func.isRequired,
    getsent: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    sendMessages: PropTypes.func.isRequired,
    changeFields: PropTypes.func.isRequired,
    errorForm: PropTypes.func.isRequired,
    getmessage: PropTypes.func.isRequired,
    setDataConcat: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getmessages: (fields: any, typeOptions: string) => dispatch(SentActions.getmessages(fields, typeOptions)),
    getsent: (fields: any, typeOptions: string) => dispatch(SentActions.getsent(fields, typeOptions)),
    setData: (item: any, name: string) => dispatch(SentActions.setData(item, name)),
    sendMessages: (fields: any, typeOptions: string) => dispatch(SentActions.sendMessages(fields, typeOptions)),
    changeFields: (fields: any) => dispatch(SentActions.changeFields(fields)),
    errorForm: (errors: any) => dispatch(SentActions.errorForm(errors)),
    getmessage: (fields: any, typeOptions: string) => dispatch(SentActions.getmessage(fields, typeOptions)),
    setDataConcat: (items: any, name: string) => dispatch(SentActions.setDataConcat(items, name))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Sent);
